import { render, staticRenderFns } from "./applyHaoka.vue?vue&type=template&id=12d874e8&scoped=true&"
import script from "./applyHaoka.vue?vue&type=script&lang=js&"
export * from "./applyHaoka.vue?vue&type=script&lang=js&"
import style0 from "./applyHaoka.vue?vue&type=style&index=0&id=12d874e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d874e8",
  null
  
)

export default component.exports